import styled from 'styled-components';

const CardConsolidationResult = styled.div`
  margin-top: 4px;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  .card-action-wrap {
    /* color: #1565c0; */
    .card-divider {
      color: rgb(176, 176, 176);
      margin: 0 6px;
    }
    .set-admin-card {
      cursor: ${(props) => (props.isAdmin ? '' : 'pointer')};
      color: ${(props) => (props.isAdmin ? '#BDBDBD ' : '#1565c0')};
    }
    .set-second-card {
      cursor: ${(props) => (props.isSecond ? '' : 'pointer')};
      color: ${(props) => (props.isSecond ? '#BDBDBD ' : '#1565c0')};
    }
  }
  .card-list-wrap {
    div {
      border-radius: 10px !important;
      .table-content {
        border-radius: 4px !important;
      }
    }
  }
  .scene-marketing-result {
    margin: 0 ${(props) => props.theme.spacing(12 / 8)}
      ${(props) => props.theme.spacing(12 / 8)}
      ${(props) => props.theme.spacing(12 / 8)};
  }
  .date-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .icon-disabled {
    width: 18px;
    height: 18px;
    fill: rgb(189, 189, 189);
    cursor: not-allowed !important;
  }
  .disabled {
    cursor: not-allowed !important;
  }
  .icon {
    width: 18px;
    height: 18px;
    vertical-align: middle;
    fill: #1565c0;
  }
  .suspend {
    width: 45px;
    height: 35px;
  }
`;

export default CardConsolidationResult;
